import { useQuery } from "react-query";
import {
  BooksResponseType,
  CategoriesResponseType,
  ClassificationsResponseType,
  PublisherResponseType,
} from "./types";
import api from "../../../services/api/api";

export const useBooks = (
  type: string,
  page: number,
  limit: number,
  options?: { suspense: boolean },
) => {
  return useQuery(
    [type, page, limit],
    () => {
      return api.get<string, BooksResponseType>(
        `/${type}?page=${page}&limit=${limit}`,
      );
    },
    {
      refetchOnWindowFocus: false,
      suspense: options?.suspense || false,
      staleTime: Infinity,
    },
  );
};

export const useCategories = () => {
  return useQuery(
    ["categories"],
    () => {
      return api.get<string, CategoriesResponseType>("/categories");
    },
    {
      refetchOnWindowFocus: false,
      suspense: true,
      staleTime: Infinity,
    },
  );
};

export const useClassifications = () => {
  return useQuery(
    ["classifications"],
    () => {
      return api.get<string, ClassificationsResponseType>("/classifications");
    },
    {
      refetchOnWindowFocus: false,
      suspense: true,
      useErrorBoundary: false,
      staleTime: Infinity,
      select: (data) =>
        [...data.classifications].sort((a, b) => a.order - b.order),
    },
  );
};

export const useClassificationBooks = (
  classificationName: string,
  page: number,
  limit: number,
) => {
  return useQuery(
    ["booksByClassification", classificationName, page, limit],
    () => {
      return api.get<string, BooksResponseType>(
        `/booksByClassification?classification=${encodeURIComponent(
          classificationName,
        )}&page=${page}&limit=${limit}`,
      );
    },
    {
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      enabled: classificationName !== "",
    },
  );
};

export const usePublishers = (fetchAll?: boolean) => {
  return useQuery(
    ["publishers", fetchAll],
    () => {
      return api.get<string, PublisherResponseType>(
        `/publishers${fetchAll !== undefined ? `?fetchAll=${fetchAll}` : ""}`,
      );
    },
    {
      refetchOnWindowFocus: false,
      suspense: !fetchAll,
      staleTime: Infinity,
    },
  );
};
